import { axios } from "../utils/axios";
import { _ } from "../utils/lodash";
import { Payment } from "./payment";

export type BookingType = "play" | "party";
export type BookingStatus = "pending" | "booked" | "in_service" | "finished" | "canceled";

export type BookingFindArgs = QueryArgs & {
  type?: BookingType;
  date?: string;
  status?: BookingStatus;
  due?: boolean;
  customerKeyword?: string;
  customer?: string;
  store?: string;
};
export interface Booking {
  id: string;
  bands: { type?: "kid" | "adult"; no: string }[];
  checkInAt: string;
  customer: any;
  date: string;
  hours: string;
  price: number;
  payments: Payment[];
  socksCount: number;
  adultsCount: number;
  status: BookingStatus;
  type: BookingType;
  store: any;
}

export interface BookingPrice {
  price: number;
  nonSpecialOfferPrice?: number;
  cardTimes?: number;
}

export interface QueryArgs {
  skip?: number;
  limit?: number;
}

export const findBookings = async (args: BookingFindArgs) => {
  const params = _.omitBy(args, _.isNil);
  return axios.request<Booking[]>({ url: "/booking", params });
};

export const getBooking = async ({ id }) => {
  return axios.request<Booking>({ url: `/booking/${id}` });
};

export const createBooking = async ({ store, type, date, hours, checkInAt, adultsCount, kidsCount, socksCount, card, useBalance, paymentGateway, customer, coupon, paymentPending, payCode }) => {
  const data = _.omitBy({ store, type, date, hours, checkInAt, adultsCount, kidsCount, socksCount, card, customer, coupon, paymentPending }, _.isNil);
  const params = _.omitBy({ useBalance, paymentGateway, payCode }, _.isNil);
  return axios.request<Booking>({
    url: `/booking`,
    params,
    method: "POST",
    data
  });
};

export const getBookingPrice = async ({ store, type, date, hours, checkInAt, adultsCount, kidsCount, socksCount, card, useBalance, paymentGateway, customer, coupon }) => {
  const data = _.omitBy({ store, type, date, hours, checkInAt, adultsCount, kidsCount, socksCount, card, customer, coupon }, _.isNil);
  return axios.request<BookingPrice>({
    url: `/booking-price`,
    params: {
      useBalance,
      paymentGateway
    },
    method: "POST",
    data
  });
};

export const updateBooking = async ({
  id,
  bands,
  status,
  hours,
  paymentGateway,
  useBalance = true
}: {
  id?: string;
  bands?: { type?: "kid" | "adult"; no: string }[];
  status?: string;
  hours?: number;
  paymentGateway?: string;
  useBalance?: boolean;
}) => {
  const data = _.omitBy({ bands, status, hours }, _.isNil);
  const params = _.omitBy({ paymentGateway, useBalance }, _.isNil);

  return axios.request<Booking>({ method: "PUT", url: `/booking/${id}`, data, params });
};

export const getBookingReceiptData = async ({ id }) => {
  return axios.request<string>({ url: `/booking/${id}/receipt-data` });
};

export const getStatseceiptData = async () => {
  return axios.request<string>({ url: `/stats-receipt-data` });
};
